import { textFormatting } from '@yola/ws-sdk';
import highlighter from 'src/js/modules/highlighter';
import trackBlockSettingsDialogCanceled from '../trackers/track-block-settings-dialog-canceled';
import isBackgroundOptionChanged from '../verifiers/is-background-option-changed';
import blockSettingsHelpers from './block-settings';

const { getChanges, hasTouchedGlobals, trackWsBlockContent } = blockSettingsHelpers;

const cancelBlockSettingsChanges = ({
  destinationBlockNode,
  isOnlineStoreBlock,
  usedCustomColorOptions,
  blockId,
  hideDialog,
  forceReloadView,
  onDialogCancel,
  optionalChildren,
  blockNode,
  displayOptions,
  backgroundOption,
  variationId,
}) => {
  trackBlockSettingsDialogCanceled({
    onDialogCancel,
    blockId,
    blockVariationId: variationId,
  });

  if (hasTouchedGlobals(optionalChildren) || destinationBlockNode || isOnlineStoreBlock) {
    highlighter.operations.hide([blockNode]);
    forceReloadView();
    hideDialog();
    return;
  }

  const [changedChildren, changesList] = getChanges({
    optionalChildren,
    displayOptions,
  });

  if (changedChildren.length) {
    trackWsBlockContent(blockNode);
  }

  if (usedCustomColorOptions) {
    textFormatting.helpers.reloadCustomColorStylesheet();
  }

  if (changedChildren.length || changesList.length || isBackgroundOptionChanged(backgroundOption)) {
    forceReloadView();
  }

  hideDialog();
};

export default cancelBlockSettingsChanges;
